"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _Columns = _interopRequireDefault(require("./Columns"));
var _Column = _interopRequireDefault(require("./Column"));
var _Button = _interopRequireDefault(require("../elements/Button"));
var _Title = _interopRequireDefault(require("../elements/Title"));
var _SubTitle = _interopRequireDefault(require("../elements/SubTitle"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Hero = _ref => {
  let {
    className,
    backgroundColor,
    color,
    size,
    intro,
    title,
    subTitle,
    fontSize,
    titleSize: titleSizeArg,
    subTitleSize: subTitleSizeArg,
    introSize: introSizeArg,
    description,
    image,
    buttonText,
    url,
    getAssetUrl,
    isFullPageWidth,
    head,
    footer,
    bodyLeft,
    bodyLeftSize,
    bodyRight,
    bodyRightSize,
    children
  } = _ref;
  const bgImage = image ? `url(${getAssetUrl ? getAssetUrl(image) : image})` : undefined;
  const classNames = (0, _classnames.default)({
    [`is-${backgroundColor}`]: backgroundColor && !backgroundColor.startsWith('#'),
    [`is-${color}`]: color,
    [`is-${size}`]: size
  });
  let titleSize = titleSizeArg || 3;
  let subTitleSize = subTitleSizeArg || 5;
  let introSize = introSizeArg || 5;
  if (fontSize === 'small') {
    titleSize = 4;
    subTitleSize = 6;
    introSize = 6;
  }
  if (fontSize === 'medium') {
    titleSize = 2;
    subTitleSize = 5;
    introSize = 5;
  }
  if (fontSize === 'large') {
    titleSize = 1;
    subTitleSize = 3;
    introSize = 3;
  }
  const titleColor = color || backgroundColor || image ? 'white' : undefined;
  const heroChildren = children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, intro && /*#__PURE__*/_react.default.createElement(_SubTitle.default, {
    text: intro,
    size: introSize,
    textColor: titleColor
  }), title && /*#__PURE__*/_react.default.createElement(_Title.default, {
    text: title,
    size: titleSize,
    textColor: titleColor
  }), (subTitle || description) && /*#__PURE__*/_react.default.createElement(_SubTitle.default, {
    text: subTitle || description,
    size: subTitleSize,
    textColor: titleColor
  }), url && buttonText && /*#__PURE__*/_react.default.createElement("div", {
    className: "buttons"
  }, url && url.startsWith('/') && /*#__PURE__*/_react.default.createElement(_Button.default, {
    renderAs: _reactRouterDom.Link,
    to: url
  }, buttonText), url && !url.startsWith('/') && /*#__PURE__*/_react.default.createElement(_Button.default, {
    renderAs: "a",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, buttonText)));
  const heroChildrenWrapped = isFullPageWidth ? /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_Columns.default, null, /*#__PURE__*/_react.default.createElement(_Column.default, {
    isTwoThirds: true
  }, heroChildren))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-body-content"
  }, heroChildren);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _classnames.default)('hero', className, classNames) || undefined,
    style: backgroundColor && backgroundColor.startsWith('#') ? {
      backgroundColor
    } : {}
  }, head && /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-head pt-5"
  }, head), /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-body",
    style: {
      backgroundImage: bgImage
    }
  }, !bodyLeft && !bodyRight ? heroChildrenWrapped : '', bodyLeft && !bodyRight ? /*#__PURE__*/_react.default.createElement(_Columns.default, null, /*#__PURE__*/_react.default.createElement(_Column.default, {
    size: bodyLeftSize,
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "center"
  }, bodyLeft), /*#__PURE__*/_react.default.createElement(_Column.default, {
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "flex-start"
  }, heroChildrenWrapped)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null), !bodyLeft && bodyRight ? /*#__PURE__*/_react.default.createElement(_Columns.default, null, /*#__PURE__*/_react.default.createElement(_Column.default, {
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "flex-start"
  }, heroChildrenWrapped), /*#__PURE__*/_react.default.createElement(_Column.default, {
    size: bodyRightSize,
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "center"
  }, bodyRight)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null), bodyLeft && bodyRight ? /*#__PURE__*/_react.default.createElement(_Columns.default, null, /*#__PURE__*/_react.default.createElement(_Column.default, {
    size: bodyLeftSize,
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "center"
  }, bodyLeft), /*#__PURE__*/_react.default.createElement(_Column.default, {
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "center"
  }, heroChildrenWrapped), /*#__PURE__*/_react.default.createElement(_Column.default, {
    size: bodyRightSize,
    isFlex: true,
    flexAlignItems: "center",
    flexJustifyContent: "center"
  }, bodyRight)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null)), footer && /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-foot"
  }, footer));
};
Hero.propTypes = {
  backgroundColor: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'small', 'medium', 'large', 'halfheight', 'fullheight']), _propTypes.default.string]),
  fontSize: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'small', 'medium', 'large']), _propTypes.default.string]),
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'info', 'link', 'success', 'warning', 'danger']), _propTypes.default.string]),
  intro: _propTypes.default.string,
  title: _propTypes.default.string,
  subTitle: _propTypes.default.string,
  titleSize: _propTypes.default.number,
  subTitleSize: _propTypes.default.number,
  introSize: _propTypes.default.number,
  description: _propTypes.default.string,
  className: _propTypes.default.string,
  image: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  url: _propTypes.default.string,
  getAssetUrl: _propTypes.default.func,
  head: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  bodyLeft: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  bodyLeftSize: _propTypes.default.number,
  bodyRight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  bodyRightSize: _propTypes.default.number,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  isFullPageWidth: _propTypes.default.bool
};
Hero.defaultProps = {
  bodyLeftSize: 1,
  bodyRightSize: 1,
  bodySize: 8
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Hero);
//# sourceMappingURL=Hero.js.map